import React from 'react';
import { WsPackstation } from '../../../ws/result/WsPackstation';
import { __ } from 'first-intl';

export type PackstationProps = { address: WsPackstation };

export const Packstation = ({
    address: { firstName, lastName, zipCode, city, postNummer, packStationsNummer },
}: PackstationProps) => (
    <>
        {__('address.description.packstation')}
        <br />
        {firstName && <span>{firstName + ' '}</span>}
        {lastName}
        <br />
        {zipCode}
        <span>{' ' + city}</span>
        <br />
        {__('address.label.postnummer')}
        {postNummer}
        <br />
        {__('address.label.packstationsnummer')}
        {packStationsNummer}
    </>
);
